import Component from '@glimmer/component'
import { service } from '@ember/service'
import { eq } from 'ember-truth-helpers'
import type { IntlService } from 'ember-intl'
import { formatNumber } from 'district-ui-client/utils/giraffe/formatter'
import { AwardsEarnedTrophy } from 'district-ui-client/components/charts/dashboard/awards-earned/trophies/trophy'
import trophyGold from '@images/awards-earned/trophy-gold.svg'
import trophySilver from '@images/awards-earned/trophy-silver.svg'
import trophyBronze from '@images/awards-earned/trophy-bronze.svg'
import type { AwardsEarnedData } from 'district-ui-client/utils/student-events/fetchers/awards-earned'

const TROPHY_COLORS = ['gold', 'silver', 'bronze'] as const
type TrophyColor = (typeof TROPHY_COLORS)[number]

export interface TrophyViewModel {
  value: string | number
  label: string
  colour: TrophyColor
  src: string
}

interface Signature {
  Element: HTMLDivElement
  Args: {
    data: AwardsEarnedData
  }
}

const trophyData: Record<TrophyColor, { labelKey: string; src: string }> = {
  gold: {
    labelKey: 'awards.gold',
    src: trophyGold,
  },
  silver: {
    labelKey: 'awards.silver',
    src: trophySilver,
  },
  bronze: {
    labelKey: 'awards.bronze',
    src: trophyBronze,
  },
}

export class AwardsEarnedTrophies extends Component<Signature> {
  @service intl!: IntlService

  get trophies(): TrophyViewModel[] {
    const earned = this.args.data
    return TROPHY_COLORS.map((colour) => {
      const info = trophyData[colour]
      return {
        value: formatNumber(earned[colour], 0),
        label: this.intl.t(info.labelKey),
        colour,
        src: info.src,
      }
    })
  }

  <template>
    <div
      class="mx-auto flex h-full max-w-md items-center justify-center px-6"
      data-test-awards-earned-trophies
      ...attributes
    >
      {{#each this.trophies as |trophy|}}
        <AwardsEarnedTrophy class="w-1/3 {{if (eq trophy.colour 'silver') 'mt-12' '-mt-12'}}" @trophy={{trophy}} />
      {{/each}}
    </div>
  </template>
}

export default AwardsEarnedTrophies
